import React from 'react';
import PropTypes from 'prop-types';
import { Wizard } from '../../../../Modules';
import EmailConfirmation from './EmailConfirmation';
import ShareOptions from './ShareOptions';

export default class ShareDocument extends React.Component {
  static propTypes = {
    document: PropTypes.object.isRequired,
    event: PropTypes.object,
    trigger: PropTypes.node.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    canEmail: PropTypes.bool.isRequired,
    title: PropTypes.string,
    shareUrl: PropTypes.string.isRequired,
    documentType: PropTypes.string.isRequired,
    permissionsNode: PropTypes.node,
    sendEmail: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.getWorkspaceContactEmails = this.getWorkspaceContactEmails.bind(this);
    this.toggleLink = this.toggleLink.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.state = {
      showLink: !this.props.canEmail,
      to: '',
      cc: ''
    };
  }

  onOpen() {
    this.setState({
      open: true,
      step: 0,
      showLink: !this.props.canEmail
    });
    if (this.props.onOpen) this.props.onOpen();
  }

  onClose() {
    this.setState({ open: false });
    if (this.props.onClose) this.props.onClose();
  }

  getWorkspaceContactEmails() {
    const contacts = [];
    const { event } = this.props;
    if (event) {
      event.user_contacts.edges.map(({ node: uc }) =>
        uc.user_contact_emails.edges.map(({ node: email }) => {
          contacts.push({
            title: `${uc.first_name} ${uc.last_name}`,
            description: email.address,
            value: email.address
          });
          return email;
        })
      );
    }
    return contacts;
  }

  toggleLink() {
    this.setState(prevState => ({ showLink: !prevState.showLink }));
  }

  sendEmail(model, resetForm, invalidateForm, successCb) {
    this.setState({ to: model.to, cc: model.cc });
    this.props.sendEmail(model, successCb);
  }

  render() {
    const { showLink, to, cc } = this.state;
    const {
      canEmail,
      title,
      shareUrl,
      documentType,
      permissionsNode,
      trigger
    } = this.props;

    const steps = [
      {
        component: ShareOptions,
        componentProps: {
          permissionsNode,
          documentType,
          shareUrl,
          emailSuggestions: this.getWorkspaceContactEmails(),
          showLink,
          toggleLink: this.toggleLink,
          canEmail
        },
        title,
        actions: {
          primary: {
            content: showLink ? 'Close' : 'Send Email',
            type: showLink ? 'button' : 'submit'
          },
          secondary: { hide: showLink }
        },
        formProps: {
          onValidSubmit: this.sendEmail,
          autoComplete: 'off'
        }
      }
    ];

    if (!showLink) {
      steps.push({
        component: EmailConfirmation,
        componentProps: { documentType, to, cc, onClose: this.onClose },
        title,
        hideActions: true
      });
    }

    return (
      <Wizard
        steps={steps}
        trigger={trigger}
        onOpen={this.onOpen}
        onClose={this.onClose}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Actions/Share/Share.js